<ui-dialog
    [open]="showXeroInProgressWarningModal"
    (closing)="showXeroInProgressWarningModal = false"
    secondaryButtonLabel="close"
    size="small"
    header="payroll.run.sendingDataToXero"
>
    <p>{{ 'payroll.run.cannotLeavePage' | translate }}</p>
</ui-dialog>

<div class="ui basic segment">
    <app-header
        [title]="
            'payroll.run.payrollComplete'
                | translate
                    : {
                          fromDate: payroll.startDate | i18nDate: 'short',
                          toDate: payroll.endDate | i18nDate: 'short',
                      }
        "
    >
        <div class="buttons">
            <a href="https://support.humi.ca/" target="_blank">{{
                'payroll.records.haveAquestionAboutPayroll' | translate
            }}</a>
        </div>
    </app-header>

    <div class="app-grid">
        <ui-card class="columns-8 medium-columns-12 large-columns-12">
            <p>
                {{ 'payroll.run.successfulPayrollRun' | translate }}
                <strong>
                    {{
                        'payroll.run.humiWillDebit'
                            | translate
                                : {
                                      amount: payroll.debitAmount | i18nNum: '$',
                                      date: payroll.paidAt | i18nDate: 'long',
                                  }
                    }}.</strong
                >
                <br />
                {{ 'payroll.run.ensureFunds' | translate }}
            </p>

            <div class="app-grid">
                <div class="flex middle columns-4 large-columns-12 margin-bottom-4 margin-top-2">
                    <div>
                        <h4>{{ 'payroll.run.payPeriod' | translate }}</h4>
                        {{ payroll.startDate | i18nDate: 'short' }} - {{ payroll.endDate | i18nDate: 'short' }}
                        <h4>{{ 'payroll.run.payDate' | translate }}</h4>
                        {{ payroll.chequeDate | i18nDate: 'short' }}
                        <h4>{{ 'payroll.run.payrollTypeHeader' | translate }}</h4>
                        {{
                            'payroll.run.payrollType'
                                | translate
                                    : {
                                          type: payrollType,
                                          period: payroll.periodNo,
                                          totalPeriods: payroll.totalPeriods,
                                      }
                        }}
                        <h4>{{ 'payroll.run.totalPayrollAmount' | translate }}</h4>
                        {{ payroll.liability | i18nNum: '$' }}
                        <ng-container *ngIf="showQhsfRate">
                            <h4>{{ 'payroll.run.qhsfRate' | translate }}</h4>
                            {{ payroll.eptSummariesQc[0].taxRate | i18nNum: '%' }}
                        </ng-container>
                    </div>
                </div>
                <div class="columns-8 large-columns-12">
                    <img src="/assets/illustrations/chair-money-plant.png" />
                </div>
            </div>

            <div class="columns-12">
                <ui-button
                    type="outline"
                    url="/payroll/records/payrolls/{{ payroll.id }}/details"
                    [externalLink]="true"
                    class="margin-right-1"
                    >{{ 'payroll.records.viewPayrollDetails' | translate }}
                    <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon
                ></ui-button>
                <ui-button type="outline" [externalLink]="true" url="{{ payrollRegisterUrl }}"
                    >{{ 'payroll.records.viewPayrollRegisterReport' | translate }}
                    <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon
                ></ui-button>
            </div>
        </ui-card>
    </div>

    <ui-card *ngIf="payroll.eptSummariesNonQc">
        <app-segment-header [title]="'payroll.run.otherRemittancesPay.otherRemittancesOwing'" />
        <app-other-remittances-pay [eptSummaries]="payroll.eptSummariesNonQc" [useBanner]="true" />
    </ui-card>

    <ui-card *ngIf="shouldShowXeroCard">
        <div class="flex width-full margin-bottom-4">
            <div class="flex width-full align-items-start">
                <img class="margin-right-3" src="assets/logos/xero-fill.png" alt="Xero" />
                <h2 class="margin-y-auto">{{ xeroCompanyName ?? ('payroll.records.xeroIntegration' | translate) }}</h2>
            </div>
            <div class="flex align-items-end">
                <ui-badge *ngIf="isConnectedToXero && !hasXeroError" type="success">{{
                    'payroll.run.connected' | translate
                }}</ui-badge>
                <ui-badge *ngIf="!isConnectedToXero || hasXeroError" type="danger">{{ 'error' | translate }}</ui-badge>
            </div>
        </div>

        <div class="progress-bar" *ngIf="isConnectedToXero && !hasXeroError">
            <span *ngIf="progress < 100" class="progress-bar-label">{{
                'payroll.run.sendingPayrollDataToXero' | translate
            }}</span>
            <span *ngIf="progress === 100" class="progress-bar-label"
                >{{ 'payroll.run.payrollDataSentToXero' | translate }}
                <mat-icon svgIcon="success" color="primary"></mat-icon
            ></span>
            <span style="float: right">{{ progress }}%</span>
            <mat-progress-bar class="margin-top-1" mode="determinate" [value]="progress"></mat-progress-bar>
        </div>

        <p *ngIf="!isConnectedToXero">{{ 'payroll.run.payrollDataCannotBeSentToXeroDisconnected' | translate }}</p>

        <p *ngIf="hasXeroError">{{ 'payroll.run.payrollDataCannotBeSentToXeroError' | translate }}</p>

        <p *ngIf="!isConnectedToXero || hasXeroError">{{ 'payroll.run.payrollDataWillNotBeSentToXero' | translate }}</p>
    </ui-card>

    <app-transactions-table [payroll]="payroll"></app-transactions-table>
</div>
